export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const phoneRegex = /^0\d{2}-\d{4}-\d{4}$/;
export const phoneNumberRegex = /^(\d{3})(\d{4})(\d{4})$/;
export const imgSrcRegex = /<img[^>]+src\s*=\s*[\\"']?([^>\\"']+)[\\"']?[^>]*>/gm;
